import { closeAllElements } from "../../actions/common";
export default function (store, ev) {
    const { id, parent, targetId, reverse, project } = ev;
    const originalTarget = store.getNearId({ id, dir: "prev" });
    let originalReverse = false;
    if (!originalTarget)
        originalReverse = true;
    closeAllElements(store);
    const originalTask = store.moveTask({
        id,
        parent,
        targetId,
        reverse,
        project,
    });
    return () => {
        if (originalTask) {
            store.in.exec("move-task", {
                ...ev,
                parent: originalTask.parent,
                targetId: originalTarget,
                project: originalTask.project,
                reverse: originalReverse,
                $meta: { skipHistory: true },
            });
        }
    };
}
//# sourceMappingURL=move.js.map